import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/** Gate the admin area to internal users (those with an access grant / role). */
export function RequireAdmin({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  if (!user?.role) return <Navigate to="/" replace />;
  return <>{children}</>;
}
